import { PrinterType } from '@posx/core';

export enum PayInOutType {
    IN = 'IN',
    OUT = 'OUT'
}

export interface IPayInOutData {
    // Type of operation (pay in or pay out)
    type: PayInOutType;
    // Amount of money
    amount: number;
    // Note/reason for the operation
    reason: string;
    // Employee who performed the operation
    employee_uid?: string;
    employee_name?: string;
    // Payment method name for the operation
    payment_method_name?: string;
    // Timestamp of the operation
    timestamp?: Date;
    humanized_print_date?: string;
}

export const PAY_IN_OUT_PRINT_TEMPLATE = [
    {
        "type": "text",
        "align": "center",
        "style": "bold",
        "item": {
            "size": "custom",
            "width": 1,
            "height": 1,
            "text": "PAY {{type}}"
        }
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "text",
        "align": "left",
        "style": "bold",
        "item": {
            "size": "custom",
            "width": 1,
            "height": 1,
            "text": "AMOUNT: {{type === 'OUT' ? '-' : ''}}${{amount}}"
        }
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "text",
        "align": "left",
        "style": "bold",
        "item": {
            "size": "custom",
            "width": 1,
            "height": 1,
            "text": "REASON: {{reason}}"
        }
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "text",
        "align": "left",
        "style": "bold",
        "item": {
            "size": "custom",
            "width": 1,
            "height": 1,
            "text": "METHOD: {{payment_method_name}}"
        }
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "text",
        "align": "left",
        "style": "bold",
        "item": {
            "size": "custom",
            "width": 1,
            "height": 1,
            "text": "BY: {{employee_name}}"
        }
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "text",
        "align": "left",
        "style": "bold",
        "item": {
            "size": "normal",
            "text": "Date: {{humanized_print_date}}"
        }
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "newline"
    },
    {
        "type": "cut"
    }
];
